import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fdcb1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "el-button me-2",
  for: "fileInput"
}, "Choose File", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  key: 6,
  class: "mt-3"
}
const _hoisted_9 = { class: "no-bullets" }
const _hoisted_10 = {
  key: 7,
  class: "mb-3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "To mass populate rooms, upload an xslx file with the following columns.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "All column names must be included in the file and match the naming convention."),
  /*#__PURE__*/_createElementVNode("li", null, "If there is a valid room id, the room will be updated with values in the file."),
  /*#__PURE__*/_createElementVNode("li", null, "If there is not a room id, a new room will be created with values in the file."),
  /*#__PURE__*/_createElementVNode("li", null, "Any non-required field can be left blank and the default value will be used."),
  /*#__PURE__*/_createElementVNode("li", null, "Any field with allowed values will use the default value if an allowed value is entered.")
], -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.roomsImporting && !_ctx.roomsUploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("input", {
            type: "file",
            id: "fileInput",
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFileChange($event.target.files[0])))
          }, null, 32),
          (_ctx.roomsToBeCreated.length > 0 || _ctx.fileName)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "info",
                onClick: _ctx.clearFile
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Clear File")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.roomsToBeCreated.length > 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _ctx.onPopulateRooms
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Populate Rooms")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showUploadInstructions)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onExportRooms(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Download Blank Template")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showUploadInstructions && _ctx.showExport)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                class: "ms-2",
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onExportRooms(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Download Existing Rooms")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.fileName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h2", null, "Selected File: " + _toDisplayString(_ctx.fileName), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.fileRoomCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Rooms in file: " + _toDisplayString(_ctx.fileRoomCount), 1))
      : _createCommentVNode("", true),
    (_ctx.fileRoomCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Rooms to create: " + _toDisplayString(_ctx.fileRoomCreateCount), 1))
      : _createCommentVNode("", true),
    (_ctx.fileRoomCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Rooms to update: " + _toDisplayString(_ctx.fileRoomUpdateCount), 1))
      : _createCommentVNode("", true),
    (_ctx.fileRoomErrors > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Rooms with errors: " + _toDisplayString(_ctx.fileRoomErrors), 1))
      : _createCommentVNode("", true),
    (_ctx.showCounts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.showProgress)
            ? (_openBlock(), _createBlock(_component_el_progress, {
                key: 0,
                "text-inside": true,
                "stroke-width": 26,
                percentage: _ctx.roomUploadProgressPercentage,
                class: "mb-2"
              }, null, 8, ["percentage"]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, "Rooms Created: " + _toDisplayString(_ctx.roomsCreatedCount), 1),
            _createElementVNode("li", null, "Rooms Updated: " + _toDisplayString(_ctx.roomsUpdatedCount), 1),
            _createElementVNode("li", null, "Locations Created: " + _toDisplayString(_ctx.locationsCreatedCount), 1),
            _createElementVNode("li", null, "Sub Locations Created: " + _toDisplayString(_ctx.subLocationsCreatedCount), 1),
            _createElementVNode("li", null, "Rooms with Errors: " + _toDisplayString(_ctx.errorsCount), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUploadInstructions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_el_table, { data: _ctx.roomColumns }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "columnName",
                label: "Column Name",
                sortable: "",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "allowedValues",
                label: "Allowed Values",
                sortable: "",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "required",
                label: "Required",
                sortable: "",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      (_ctx.roomsToBeCreated.length > 0 || _ctx.fileName)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _ctx.roomsToBeCreated
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "",
                "show-overflow-tooltip": "",
                width: "35px"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.errorMsg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: scope.row.errorMsg,
                          placement: "bottom-start",
                          "show-after": 500,
                          "hide-after": 0
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Icon, {
                              class: "icon icon--x-large icon--danger",
                              icon: _ctx.mdiAlertCircle
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (scope.row.existingRoom)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              effect: "dark",
                              content: "Update room",
                              placement: "bottom-start",
                              "show-after": 500,
                              "hide-after": 0
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  class: "icon icon--x-large icon--warning",
                                  icon: _ctx.mdiPencilCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!scope.row.existingRoom)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              effect: "dark",
                              content: "Create room",
                              placement: "bottom-start",
                              "show-after": 500,
                              "hide-after": 0
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  class: "icon icon--x-large icon--color",
                                  icon: _ctx.mdiPlusCircleOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Room ID",
                prop: "id",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "Room Name",
                prop: "roomName",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "roomCode",
                label: "Room Code",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.invalidRoomCode)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: scope.row.invalidRoomCodeText,
                        placement: "bottom-start",
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.roomCode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableMirroring",
                label: "Enable Mirroring Code",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableSignage",
                label: "Enable Signage",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.enableSignage && !_ctx.hasSignage)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: _ctx.noImportText,
                        placement: "bottom-start",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.enableSignage), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableHigherResolution",
                label: "Enable Native Resolution",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.enableHigherResolutionOverride)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: "Overrides organization setting",
                        placement: "bottom-start",
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.enableHigherResolution), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "showConnectionInfo",
                label: "Show Connection Info",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "connectionInfoPosition",
                label: "Connection Info Location",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "showSignageDateTime",
                label: "Show Date and Time on Signage",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.showSignageDateTimeOverride)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: "Overrides organization setting",
                        placement: "bottom-start",
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.showSignageDateTime), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "signageDateTimeLocation",
                label: "Date and Time Location",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.signageDateTimeLocationOverride)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: "Overrides organization setting",
                        placement: "bottom-start",
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.signageDateTimeLocation), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableAlerts",
                label: "Enable Alerts",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.enableAlerts && !_ctx.hasAlerts)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: _ctx.noImportText,
                        placement: "bottom-start",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.enableAlerts), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableModeratorControls",
                label: "Enable Moderator Controls",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.enableModeratorControls && !_ctx.hasModeratorControls)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: _ctx.noImportText,
                        placement: "bottom-start",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.enableModeratorControls), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "moderatorConnectionType",
                label: "Moderator Connection Type",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.moderatorConnectionType && !_ctx.hasModeratorControls)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: _ctx.noImportText,
                        placement: "bottom-start",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.moderatorConnectionType), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "moderatorPassword",
                label: "Moderator Password",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  (scope.row.moderatorPassword && !_ctx.hasModeratorControls)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "dark",
                        content: _ctx.noImportText,
                        placement: "bottom-start",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            class: "icon--danger icon--large",
                            icon: _ctx.mdiAlertCircleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(scope.row.moderatorPassword), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "locationName",
                label: "Location Name",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "subLocationName",
                label: "Sub Location Name",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.roomsImporting || _ctx.roomsUploading]
    ])
  ], 64))
}